import {
  getBusinnessTypeDetails,
  hasMatchedBusiness,
  isOpeningSoon,
} from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_utils/signupUtilities";
import { IMatchedBusiness } from "@faire/web-api--source/indigofair/data/IMatchedBusiness";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";

export const stringifyMatchBusiness = (
  matchBusiness?: IMatchedBusiness
): string => {
  return [
    matchBusiness?.id,
    matchBusiness?.type,
    matchBusiness?.name,
    matchBusiness?.location,
    matchBusiness?.state,
    matchBusiness?.google_place_types.join(","),
  ]
    .map((token) => token ?? "")
    .join("|");
};

/**
 * Postal code is optional if creation time is opening soon or if the retailer does not have a physical store
 */
export const isPostalCodeOptional = (
  creationTime: keyof typeof IRetailer.ReportedCreationTime | undefined,
  businessPlatforms: string[] | undefined,
  matchBusiness?: IMatchedBusiness
): boolean => {
  const { hasPhysicalStore } = getBusinnessTypeDetails(businessPlatforms);

  return (
    isOpeningSoon(creationTime) ||
    !hasPhysicalStore ||
    hasMatchedBusiness(matchBusiness)
  );
};
